// modules
import React from 'react'
import { useSelector } from 'react-redux'
// components
import { Redirect, useLocation } from 'react-router-dom'

import { get } from 'lodash'

// store
import { isUserAuthorized$ } from 'src/store/modules/auth'

const WithoutAuth = (Component: React.FC) => {
  const WithoutAuthWrapper = (props) => {
    const isUserAuthorized = useSelector(isUserAuthorized$)
    const location = useLocation()

    if (!isUserAuthorized) {
      return <Component {...props} />
    }

    return <Redirect to={get(location, ['state', 'referrer'], '/')} />
  }

  return WithoutAuthWrapper
}

export default WithoutAuth
